"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _oxygenConstants = require("@8x8/oxygen-constants");

var slideOut = {
  splitterSize: _oxygenConstants.size["default"],
  splitterCursor: 'col-resize',
  animationSpeed: _oxygenConstants.timing.fast,
  background: _oxygenConstants.color.white,
  boxShadowColor: '#000',
  boxShadowOpacity: 0.25,
  boxShadowSize: _oxygenConstants.size.shadowMedium
};
var _default = slideOut;
exports["default"] = _default;